import * as React from 'react'

import PopupModal from '../../../../components/home/PopupModal/PopupModal'
import useWindowSize from '../../../../services/hooks/useWindowSize'

const phoneMaxWidth = 767.98

const PopupModalPreview = props => {
  const [
    width,
    // , height
  ] = useWindowSize()
  const [desktop, isDesktop] = React.useState(true)

  React.useEffect(() => {
    const { innerWidth } = window || {}
    if (innerWidth > phoneMaxWidth) isDesktop(true)
    else isDesktop(false)
  }, [width])

  const shouldShow = popup => {
    if (desktop) return popup.desktopView
    else return popup.mobileView
  }

  const { popupPreview = {} } = props
  const showPopup = shouldShow(popupPreview)
  return <PopupModal data={popupPreview} show={showPopup} desktop={desktop} />
}

PopupModalPreview.defaultProps = {
  // TODO: specify default props
}

PopupModalPreview.propTypes = {
  // TODO: specify prop types
}

export default PopupModalPreview
